document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".TestimonialNav");

  function initializeSlick() {
    sections.forEach((container) => {
      if (window.innerWidth <= 768 && !$(container).hasClass("slick-initialized")) {
        $(container).slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: false,
          infinite: false,
          centerMode: true,
          centerPadding: "20%",
          autoplay: true,
          autoplaySpeed: 2950,
          pauseOnHover: false,
          pauseOnFocus: false,
        });

        $(container).on("afterChange", function (event, slick, currentSlide) {
          let index = currentSlide;
          setTimeout(function () {
            if (currentSlide === slick.$slides.length - 1) {
              index = 0;
            } else {
              index++;
            }

            $(container).slick("slickGoTo", index);
          }, 2550);
        });

        container.addEventListener("click", function (event) {
          const clickedItem = event.target.closest(".slick-slide");
          if (clickedItem) {
            const slideIndex = $(clickedItem).data("slick-index");

            $(container).slick("slickGoTo", slideIndex);
          }
        });
      }
    });
  }

  function destroySlick() {
    sections.forEach((container) => {
      if (window.innerWidth > 768 && $(container).hasClass("slick-initialized")) {
        $(container).slick("unslick");
      }
    });
  }

  initializeSlick();

  window.addEventListener("resize", function () {
    initializeSlick();
    destroySlick();
  });
});
